import {declareEvent} from 'external/dev_april_corgi+/js/corgi/events';

export const GRAPH_DIRTIED = declareEvent<{}>('petri.client.graph_dirtied');
export const SAVE = declareEvent<{}>('petri.client.save');
